import React, {createRef, useState} from "react";
import styles from './FJVideoItem.module.less';
import FJImage from "fj-components/FJImage";
import $ from "jquery";
import FJLocalStore from "../../../../../store/FJLocalStore";
import FJAddButton from "../FJAddButton";
import classNames from 'classnames'
import FJUtil from "../../../../../util/FJUtil";

function FJVideoItem(props) {

  const [thumbnailStatus, updateThumbnailStatus] = useState();
  const {videoUrl, thumbnail, width, format, duration, height, info, onSubmit, id, selected, keywords, onPreview} = props;
  const videoBoxRef = createRef();
  let video = null;

  /**
   * @description 鼠标移动到素材的区域
   * @private
   */
  const _onMouseEnter = () => {
    if (thumbnailStatus === 'success') {
      video = document.createElement('video');
      video.src = videoUrl;
      video.loop = true;
      video.autoplay = true;
      $(video).addClass(styles.video);
      videoBoxRef.current.appendChild(video);
    }
  };

  /**
   * @description 鼠标离开素材的区域
   * @private
   */
  const _onMouseLeave = () => {
    $(videoBoxRef.current).empty();
    video = null;
  };

  const _addStock = (e) => {
    e.stopPropagation();
    onSubmit(id, selected, '', {thumbnail, name: info, duration});
  }

  const _showModal = () => {
    onPreview({
      id,
      title: info,
      keywords: keywords,
      duration,
      thumbnail,
      url: videoUrl,
      format: format,
      headerTitle: FJLocalStore._('preview-video'),
      type: 'video',
      selected,
      onSubmit: _addStock,
    })
  }

  return (
    <li className={styles.li_box}
        style={{width, height}}
        onMouseEnter={_onMouseEnter}
        onMouseLeave={_onMouseLeave}
    >
      <div className={styles.list_content}>
        <FJImage url={thumbnail} imgAdapt='cover' setImgLoadStatus={updateThumbnailStatus}/>
	      {
	      	thumbnailStatus === 'success' &&
			      <>
				      <span className={styles.duration_box}>{FJUtil.formatTime(duration)}</span>
				      <div className={classNames(styles.mask_layer, {[styles.selected]: selected})} onClick={_showModal}>
					      <div ref={videoBoxRef} className={styles.video_box}/>
					      {format && <span className={styles.power}>{format}</span>}
					      <span className={styles.info}>{info}</span>
					      <FJAddButton onClick={_addStock} selected={selected} className={styles.add_btn}/>
				      </div>
			      </>
	      }
      </div>
    </li>
  )

}

export default FJVideoItem;